import { useEffect, useReducer, useState } from "react";

const formStateReducer = (state, action) => {
  let parsedValue = { actionValue: "", stateValue: "" };
  let prevState = state;
  switch (action.inputType) {
    case "number":
      parsedValue.actionValue = +action.value;
      break;
    default:
      parsedValue.actionValue = action.value;
      break;
  }

  switch (action.type) {
    case "submit":
      for (const input in state.inputs) {
        if (state.inputs[input].value === undefined) {
          for (const subInput in state.inputs[input]) {
            prevState.inputs[input][subInput].isTouched = true;
          }
        } else {
          prevState.inputs[input].isTouched = true;
        }
      }
      return {
        hasError: false,
        isValid: prevState.isValid,
        inputs: prevState.inputs,
        valuesToValidate: prevState.valuesToValidate,
      };
    case "change":
      if (action.parentName != null) {
        prevState.valuesToValidate[action.parentName][action.inputId] =
          parsedValue.actionValue;
        prevState.inputs[action.parentName][action.inputId].value =
          parsedValue.actionValue;
        prevState.inputs[action.parentName][action.inputId].hasError = false;
        if (
          action.inputType === "number" &&
          !state.inputs[action.parentName][action.inputId].isTouched
        ) {
          prevState.inputs[action.parentName][action.inputId].isTouched = true;
        }
      } else {
        prevState.valuesToValidate[action.inputId] = parsedValue.actionValue;
        prevState.inputs[action.inputId].value = parsedValue.actionValue;
        prevState.inputs[action.inputId].hasError = false;
        if (
          action.inputType === "number" &&
          !state.inputs[action.inputId].isTouched
        ) {
          prevState.inputs[action.inputId].isTouched = true;
        }
        if (
          action.inputType === "checkbox"
        ) {
          prevState.inputs[action.inputId].isTouched = true;
          prevState.inputs[action.inputId].checked = action.checked;
          prevState.inputs[action.inputId].value = action.checked;
        }
      }

      return {
        hasError: undefined,
        isValid: prevState.isValid,
        inputs: prevState.inputs,
        valuesToValidate: prevState.valuesToValidate,
      };
    case "blur":
      if (action.parentName != null) {
        prevState.inputs[action.parentName][action.inputId].isTouched = true;
        prevState.inputs[action.parentName][action.inputId].hasError = false;
      } else {
        prevState.inputs[action.inputId].isTouched = true;
        prevState.inputs[action.inputId].hasError = false;
      }
      return {
        hasError: undefined,
        isValid: prevState.isValid,
        inputs: prevState.inputs,
        valuesToValidate: prevState.valuesToValidate,
      };
    case "reset":
      return { id: state.id, value: "", isTouched: false };
    default:
      return formStateReducer;
  }
};

const useForm = (validator, inputs) => {
 const [props, setfirst] = useState(inputs)
//   useEffect(() => {
//     setfirst(inputs)
  
    
//   }, [inputs])
  
  const valueChangeHandler = (event, parentName = null) => {
    dispatch({
      type: event.type,
      value: event.target.value,
      inputType: event.target.type,
      checked: event.target.checked,
      inputId: event.target.name,
      parentName: parentName,
    });
  };

  const inputBlurHandler = (event, parentName) => {
    dispatch({
      type: event.type,
      inputType: event.target.type,
      inputId: event.target.name,
      parentName: parentName,
    });
  };

  //   const reset = () => {
  //     dispatch({ type: "RESET" });
  //   };

  const setInputsProperties = (inputs) => {
    let form = {
      inputs: inputs,
      valuesToValidate: {},
    };
    for (const input in form.inputs) {
      if (inputs[input].value === undefined) {
        let object = setInputsProperties(inputs[input]);
        form.inputs[input] = object.inputs;
        form.valuesToValidate[input] = object.valuesToValidate;
      } else {
        form.valuesToValidate[input] = form.inputs[input].value;
        form.inputs[input].inputBlurHandler = inputBlurHandler;
        form.inputs[input].valueChangeHandler = valueChangeHandler;
      }
    }
    return form;
  };
  const form = setInputsProperties(props);

  const [formState, dispatch] = useReducer(formStateReducer, {
    inputs: form.inputs,
    valuesToValidate: form.valuesToValidate,
    hasError: undefined,
    isValid: undefined,
  });


  const errorMessages = validator.validate(formState.valuesToValidate);

  const checkForm = (messages) => {
    let valid = false;
    if (Object.entries(messages).length !== 0) {
      for (const message in messages) {
        if (formState.inputs[message].value === undefined) {
          for (const subMessage in messages[message]) {
            if (formState.inputs[message][subMessage].isTouched) {
              valid = false;
              formState.hasError = true;
              formState.inputs[message][subMessage].hasError = true;
            }
          }
        } else {
          if (formState.inputs[message].isTouched) {
            valid = false;
            formState.hasError = true;
            formState.inputs[message].hasError = true;
          }
        }
      }
    } else {
      for (const input in formState.inputs) {
        if (formState.inputs[input].value === undefined) {
          for (const subInput in props[input]) {
            if (formState.inputs[input][subInput].isTouched) {
              valid = true;
              formState.hasError = false;
            } else {
              return (valid = false);
            }
          }
        } else {
          if (formState.inputs[input].isTouched) {
            valid = true;
            formState.inputs[input].hasError = false;
          } else {
            return (valid = false);
          }
        }
      }
    }
    return valid;
  };

  formState.isValid = checkForm(errorMessages);

  const submitValidationHandler = (event) => {
    if (!formState.isValid) {
      dispatch({ type: event.type });
    }
  };

  return {
    inputs: formState.inputs,
    isValid: formState.isValid,
    hasError: formState.hasError,
    errorMessages,
    submitValidationHandler,
  };
};

export default useForm;
